import { jsx } from 'react/jsx-runtime';
import cn from 'classnames';
import { Portal } from '../Portal/Portal.js';
import S from './Paranja.styl.js';

const Paranja = ({ className, children, visible = true, inline = false, blur = false, }) => {
    const classes = cn(S.root, visible && S.visible, blur && S.blur, className);
    const node = jsx("div", { className: classes, children: children });
    if (inline)
        return node;
    return jsx(Portal, { children: node });
};

export { Paranja };
